import styled from 'styled-components';

export const ListWrap = styled.ul`
  display: flex;
  flex-flow: row wrap;


  li {
    flex-basis: ${props => props.main ? "20%" : "25%"};
    margin: 30px 0 30px 0;

    @media (max-width: 992px) {
      flex-basis: 50%;
      margin-top: 0;
    }
   }
   li:nth-child(-n + 2) a {
     @media (max-width: 768px) {
       margin-top: 0;
     }
   }

  div {
    width: 160px;
    height: 160px;
    margin: 0 auto 15px;
    border: 2px solid #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 992px){
      width: 120px;
      height: 120px;
    }

    @media (max-width: 480px){
      margin-bottom: 5px;
      width: 100px;
      height: 100px;
    }
  }

  a {
    display: block;
    text-align: center;

    @media (max-width: 1000px){
      margin-top: 30px;
    }

    @media (max-width: 768px){
      margin-top: 45px;
    }

    &:hover {
      h3 {
        color: #edbd2f;
      }
      div {
        border-color: #da9c15;
        transition: all .35s linear;
      }
    }
  }

  h3 {
    color: #fff;
    position: relative;
    display: inline;
    font-size: 19px;
    transition: color .35s linear;
  }

  img {
    width: 130px;
    height: 130px;

    @media (max-width: 992px){
      width: 90px;
      height: 90px;
    }

    @media (max-width: 480px){
      width: 80px;
      height: 80px;
    }
  }
`;

export const DetailListWrap = styled.ul`
  font-size: 18px;
  margin-top: 60px;
  @media (max-width: 768px){
    margin-top: 30px;
    font-size: 14px;
  }

  li {
    padding: 10px 0;
    border-bottom: 1px solid #fff;



    span {
      font-weight: 700;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/system/list/components.js